export default "__VITE_ASSET__LkCrYmUV__"